










































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ContactMergeData } from '@contacts/interfaces/contact-merge-data';
import { HideContactMergeFields } from '@contacts/interfaces/hide-contact-merge-fields';
import Input from '@shared/components/forms/inputs/input/input.vue';

@Component({
  name: 'bc-merge-contact-summary-fields',
  components: {
    'bc-input': Input,
  },
})
export default class MergeContactSummaryFields extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly contact: ContactMergeData;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly hideFieldsList: HideContactMergeFields;
  @Prop({
    type: String,
    default: null,
  })
  readonly contactType: string;
  @Prop({
    type: Boolean,
    default: false,
  })
  readonly disabled: boolean;

  get contactFullname(): string {
    return this.contact?.fullname || '';
  }
  get contactLanguage(): string {
    return this.contact?.language || '';
  }
  get contactFirstname(): string {
    return this.contact?.firstname || '';
  }
  get contactLastname(): string {
    return this.contact?.lastname || '';
  }
  get contactGender(): string {
    return this.contact?.gender || '';
  }
  get contactBirthdate(): string {
    return this.$bpcHelper.formatDate(this.contact?.birthdate) || '';
  }
  get contactStreet(): string {
    return this.contact?.street || '';
  }
  get contactStreet2(): string {
    return this.contact?.street2 || '';
  }
  get contactZip(): string {
    return this.contact?.zip || '';
  }
  get contactCity(): string {
    return this.contact?.city || '';
  }
  get contactCountry(): string {
    return this.contact?.country || '';
  }
  get contactPhone1(): string {
    return this.contact?.phone1 || '';
  }
  get contactPhone2(): string {
    return this.contact?.phone2 || '';
  }
  get contactPhone3(): string {
    return this.contact?.phone3 || '';
  }
  get contactEmail1(): string {
    return this.contact?.email1 || '';
  }
  get contactEmail2(): string {
    return this.contact?.email2 || '';
  }
}
